import { IFramework, IWebServiceManager, HttpMethod } from '@truckdown/framework';
import { ClientRestrictionStatus } from '../main';
import { IThrottler } from './IThrottler';
import { ThrottleResponse } from './Models/ThrottleResponse';
import { ResultModel } from './ResultModel';

export class Throttler implements IThrottler {
    constructor(framework: IFramework) {
        this.manager = framework.getRequiredService<IWebServiceManager>('IWebServiceManager');
    }

    readonly manager: IWebServiceManager;
    private readonly basePath: string = '/tools/throttling/';

    throttle(name: string): Promise<ThrottleResponse> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath + encodeURIComponent(name),
            method: HttpMethod.GET
        });

        return this.manager
            .get<any>(req)
            .then((res) => {
                return new ThrottleResponse(res);
            });
    }

    async getStatus(name: string): Promise<ClientRestrictionStatus> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: this.basePath + 'status/' + encodeURIComponent(name),
            method: HttpMethod.GET
        });

        var res = await this.manager
            .get<ResultModel<ClientRestrictionStatus>>(req);
        return res.res;
    }
}